<template>
  <GridBase leed-platinum>
    <h2><TextBlock file="green/leed-platinum-h1" class="pre-line" /></h2>
    <section class="sec1">
      <div class="image">
        <img src="/img/esg/leed-platinum-logo.png" alt="">
      </div>
      <div class="txt">
        <ul>
          <li>
            <dl>
              <dt><TextBlock file="green/leed-platinum-t1" class="pre-line" /></dt>
              <dd><TextBlock file="green/leed-platinum-t2" class="pre-line" /></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><TextBlock file="green/leed-platinum-t3" class="pre-line" /></dt>
              <dd><TextBlock file="green/leed-platinum-t4" class="pre-line" /></dd>
              <dd class="desc"><TextBlock file="green/leed-platinum-t5" class="pre-line" /></dd>
            </dl>
          </li>
        </ul>
      </div>
    </section>
    <grid-base grey class="sec2">
      <div class="image-wrap">
        <div class="img"></div>
      </div>
      <div class="inner-wrap">
        <ul>
          <li>
            <div>
              <p>데이터센터 각 세종</p>
              <p><b class="score">86</b><s>점</s></p>
              <p class="txt-grey"><b>LEED V4</b><s>기준</s></p>
            </div>
          </li>
          <li>
            <div>
              <p>데이터센터 각 춘천</p>
              <p><b class="score">95</b><s>점</s></p>
              <p class="txt-grey"><b>LEED V3</b><s>기준</s></p>
            </div>
          </li>
        </ul>
        <div class="txt">
          <p><span>LEED Platinum</span> 달성</p>
          <p class="txt-grey">* 최고 점수 110점 기준</p>
          <p class="txt-grey">* 각 세종은 각 춘천이 받은 V3 대비 <br class='hidden-xxl-up'>보다 강화된 기준인 V4로 평가 받았습니다.</p>
        </div>
      </div>
    </grid-base>
    <section class="sec3">
      <h3>세계가 인정한<br />친환경 데이터센터</h3>
      <div class="inner-wrap">
        <ul class="list">
          <li class="item" v-for="(item, idx) in feature" :key="idx">
            <p class="date" v-html="item.date"></p>
            <div class="txt">
              <p class="title" v-html="item.title"></p>
              <p class="desc" v-html="item.desc"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <quick-link>
      <quick-link-item><router-link to="/esg/green-energy">Green Energy</router-link></quick-link-item>
      <quick-link-item><router-link to="/data/our-idea">Our Idea</router-link></quick-link-item>
    </quick-link>
  </GridBase>
</template>

<script>
import GridBase from '@/views/components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import feature from '@/data/esg/platinumFeature';
import TextBlock from '@/views/components/TextBlock';

export default {
  name: 'leed-platinum',
  components: { TextBlock, QuickLinkItem, QuickLink, GridBase },
  data() {
    return {
      feature,
    };
  },
};
</script>
